import React, { Suspense } from 'react';
import StickyBox from 'react-sticky-box';
import { useBenzingaEdge } from '@benzinga/edge';
import { NoFirstRender, useFirstInteractionMade } from '@benzinga/hooks';
import AboutQuote from './AboutQuote';
import { MetricsSidebar } from './MetricsSidebar';
import { BaseQuoteProfile, QuoteFund } from '../../utils/quote/types';
import ETFQuoteSidebar from './ETFQuoteSidebar';
import { ShortInterest } from '@benzinga/quotes-manager';
import { QuoteTechnicals } from '../../entities/quoteEntity';
import { Financials } from '@benzinga/securities-manager';

const ConnatixLivePlayer = React.lazy(() =>
  import('@benzinga/ads').then(module => ({
    default: module.ConnatixLivePlayer,
  })),
);

const FreestarAd = React.lazy(() =>
  import('@benzinga/ads').then(module => ({ default: module.FreestarAd })),
);

const ConnatixInitialHeadScript = React.lazy(() =>
  import('@benzinga/ads').then(module => {
    return { default: module.ConnatixInitialHeadScript };
  }),
);

export interface QuoteSidebarProps {
  isCrypto: boolean;
  isETF: boolean;
  profile: BaseQuoteProfile;
  symbol: string;
  etfFund: QuoteFund | null;
  fundamentals: Financials | null;
  technicals: QuoteTechnicals;
  shortInterest: ShortInterest[] | null;
}

export const QuotePageSidebar: React.FC<QuoteSidebarProps> = ({
  isCrypto,
  isETF,
  profile,
  etfFund,
  fundamentals,
  technicals,
  shortInterest,
}) => {
  const wasFirstInteractionMade = useFirstInteractionMade();
  const hasAdLight = useBenzingaEdge().adLightEnabled;
  return (
    <>
      {wasFirstInteractionMade && !hasAdLight ? <ConnatixInitialHeadScript cid="89cc050a-c0fc-4f72-a746-d63fbd3dee72" /> : null}
      <div className="w-full lg:w-4/12 flex flex-col items-center gap-4">
        <div className="metrics-desktop w-full">
          <MetricsSidebar
            fundamentals={fundamentals}
            technicals={technicals}
            shortInterest={shortInterest}
            etfFund={etfFund}
            isCrypto={isCrypto}
            isETF={isETF}
            profile={profile}
          />
        </div>
        {!isCrypto && <AboutQuote profile={profile} />}
        <StickyBox className="z-[1]" offsetTop={290} offsetBottom={0}>
          <div className="sidebar-ad-container flex flex-col gap-4">
            <Suspense fallback={<div />}>
              {wasFirstInteractionMade && !hasAdLight && (
                <NoFirstRender>
                  <ConnatixLivePlayer
                    cid="89cc050a-c0fc-4f72-a746-d63fbd3dee72"
                    id="c1a731da3b7e4365831fbd05ef0e83b2"
                    pid="775ce337-8729-4abf-9ac1-35656aa1d770"
                  />
                </NoFirstRender>
              )}
            </Suspense>
            {/* <Suspense fallback={<div />}>
            <WNSTNWidgetQuote isCrypto={isCrypto} symbol={symbol} />
          </Suspense> */}
            <FreestarAd
              className="w-[300px] overflow-hidden"
              disableMargins={true}
              onlyDesktop={true}
              placement="sidebar_1"
            />
          </div>
        </StickyBox>
        {!hasAdLight ? (
          <FreestarAd
            className="w-[300px] overflow-hidden"
            disableMargins={true}
            minimumHeightEnabled={false}
            onlyMobile={true}
            placement="incontent"
          />
        ) : null}
        {isETF && <ETFQuoteSidebar etfFund={etfFund} profile={profile} />}
      </div>
    </>
  );
};
